<template>
  <div>
    <div class="row align-items-center">
      <div class="col-md-8">
<!--        <a-tag color="red" v-if="data.school_id == 16 && (data.class_id == 69 || data.class_id == 70 || data.class_id == 71 || data.class_id == 72 )">
          Online fee payment is not yet available for Class 9 to 12
        </a-tag>-->
        <h5 class="font-weight-bold mb-0">{{ data.student.first_name }} {{ data.student.last_name }}</h5>
        <p>
          <span class="pr-2">Student Code:</span> <span class="font-weight-bold px-2">{{ data.student_code }}</span>|
          <span class="px-2">Class:</span> <span class="font-weight-bold px-2">{{ data.school_class ? data.school_class.name : 'Not Assigned' }}</span>|
          <span class="px-2">Section:</span> <span class="font-weight-bold px-2">{{ data.section ? data.section.name : 'Not Assigned' }}</span>|
          <span class="px-2">Roll No:</span> <span class="font-weight-bold px-2">{{ data.roll_no }}</span>
        </p>
      </div>
      <div class="col-md-4 text-md-right">
        <button
          type="button"
          class="btn btn-sm btn-primary btn-with-addon"
          :disabled="!hasOnlinePayableFees"
          @click="handlePayAll(data, schoolId, studentCode)"
        >
          <span class="btn-addon">
            <i class="btn-addon-icon fe fe-credit-card" />
          </span>
          Pay Multiple Fees
        </button>
      </div>
    </div>

    <hr class="m-0">

    <div class="row">
      <div class="col-md-12">
        <div v-for="(studentFees, groupName) in feeGroups.groups" :key="groupName" class="mt-3">
          <p class="text-muted mb-2">{{ groupName }}</p>
          <vue-custom-scrollbar class="scroll-area">
            <table class="table table-borderless">
              <thead class="bg-light">
              <tr>
                <th>Fees</th>
                <th>Amount</th>
                <th>Fine</th>
                <th>Disc.</th>
                <th>Disc. %</th>
                <th>Due</th>
                <th v-if="feeGroups.isByCategory || groupName !== 'One Time Fees'">Type</th>
                <th>Total</th>
                <th>Due Date</th>
                <th>Status</th>
                <th class="text-right">Actions</th>
              </tr>
              </thead>
              <tbody v-if="studentFees.length > 0">
              <tr
                v-for="studentFee in studentFees"
                :key="studentFee.id"
              >
                <th>{{ getFeeName(studentFee) }}</th>
                <td class="font-weight-bold">₹ {{ studentFee.amount }}</td>
                <td class="font-weight-bold">₹ {{ studentFee.fine == null ? 0 : studentFee.fine}}</td>
                <td class="font-weight-bold">₹ {{ studentFee.discount_amount == null ? 0 : studentFee.discount_amount}}</td>
                <td class="font-weight-bold">{{ studentFee.discount_percentage == null ? 0 : studentFee.discount_percentage}} %</td>
                <td class="font-weight-bold">₹ {{ studentFee.due_amount }}</td>
                <td v-if="feeGroups.isByCategory || groupName !== 'One Time Fees'" class="font-weight-bold">{{ getFeeType(studentFee.fees_fee_type) }}</td>
                <td class="font-weight-bold">₹ {{ studentFee.fee_total }}</td>
                <td class="text-danger">{{ studentFee.due_date ? moment(studentFee.due_date).format(dateFormat): null }}</td>
                <td class="font-weight-bold">{{ studentFee.payment_status ? 'Paid' : 'Not Paid' }}</td>
                <td class="text-right">
                  <template v-if="studentFee.payment_status != 1 && studentFee.is_online_payable === false">
                    <span class="badge badge-warning py-1 px-2 text-dark font-weight-normal mr-2" style="font-size: 11px;">
                      <i class="fe fe-alert-circle mr-1" />Pay at Counter
                    </span>
                  </template>
                  <template v-else>
                    <a
                      href="javascript:;"
                      :class="['p-1 mr-2 text-primary neo-icon-btn', `${studentFee.payment_status ? 'bg-light text-muted' : ''}`]"
                      @click="handlePaySingle(studentFee, schoolId, studentCode)"
                      :disabled="studentFee.payment_status === 1"
                    >
                      <i class="fe fe-credit-card" /> Pay
                    </a>
                  </template>
                  <a
                    href="javascript:;"
                    :class="['p-1 text-primary neo-icon-btn', `${studentFee.payment_status != 1 ? 'bg-light text-muted' : ''}`]"
                    @click="handleViewReceipt(studentFee, data)"
                    :disabled="studentFee.payment_status != 1"
                  >
                    <i class="fe fe-eye mr-2" /> Receipt
                  </a>
                </td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td colspan="11" class="pt-3">
                  <a-tag color="orange">No fees have been generated yet!</a-tag>
                </td>
              </tr>
              </tbody>
            </table>
          </vue-custom-scrollbar>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { find, groupBy } from 'lodash'
import moment from 'moment'

import { feeTypes } from '@/services/globaldata'

import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  name: 'ShowStudentFees',
  props: ['data', 'schoolId', 'studentCode'],
  components: {
    vueCustomScrollbar,
  },
  data: function() {
    return {
      feeTypes,
      dateFormat: 'DD-MM-YYYY',
    }
  },
  computed: {
    feeGroups() {
      if (!this.data || !this.data.student_fees || this.data.student_fees.length === 0) {
        return { groups: {}, isByCategory: false }
      }
      const studentFees = this.data.student_fees

      const getCategory = item => (item.fee_setting.class_fee && item.fee_setting.class_fee.fee && item.fee_setting.class_fee.fee.category) || (item.fee_setting.fee && item.fee_setting.fee.category)

      const isByCategory = studentFees.some(getCategory)

      if (isByCategory) {
        const groups = groupBy(studentFees, getCategory)
        return {
          groups: groups,
          isByCategory: true,
        }
      } else {
        const groups = {}
        const oneTime = studentFees.filter(element => element.fees_fee_type === 1)
        if (oneTime.length > 0) groups['One Time Fees'] = oneTime

        const recurring = studentFees.filter(studentFee => studentFee.fees_fee_type !== 1 && studentFee.fee_setting.class_fee)
        if (recurring.length > 0) groups['Recurring Fees'] = recurring

        const individual = studentFees.filter(studentFee => (studentFee.fee_setting.fee ? studentFee.fee_setting.fee.target_type === 3 : false))
        if (individual.length > 0) groups['Custom Fees'] = individual

        return {
          groups: groups,
          isByCategory: false,
        }
      }
    },
    hasOnlinePayableFees() {
      if (!this.data || !this.data.student_fees || this.data.student_fees.length === 0) {
        return false
      }
      return this.data.student_fees.some(
        fee => fee.payment_status !== 1 && fee.is_online_payable !== false
      )
    },
  },
  methods: {
    moment,
    getFeeName(studentFee) {
      if (studentFee.fee_setting.class_fee && studentFee.fee_setting.class_fee.fee) {
        return studentFee.fee_setting.class_fee.fee.name
      }
      if (studentFee.fee_setting.fee) {
        return studentFee.fee_setting.fee.name
      }
      return ''
    },
    getFeeType(type) {
      const feeType = find(this.feeTypes, { value: type })
      return feeType ? feeType.name : ''
    },
    handlePayAll(data, schoolId, studentCode) {
      this.$eventBus.$emit('openPublicPayStudentFeesModal', data, schoolId, studentCode, 'PAYALL')
    },
    handlePaySingle(studentFee, schoolId, studentCode) {
      let studentFeesArr = []
      studentFeesArr.push(studentFee)
      this.$eventBus.$emit('openPublicPayStudentFeesModal', studentFeesArr, schoolId, studentCode, 'PAYSINGLE')
    },
    handleViewReceipt(studentFee, data) {
      const student = {
        first_name: data.student.first_name,
        last_name: data.student.last_name,
        student_code: data.student_code,
        class_name: data.school_class.name,
        section_name: data.section ? data.section.name : 'NA',
        roll_no: data.roll_no,
        id: data.student.id,
      }
      this.$eventBus.$emit('openViewStudentFeeReceiptModal', studentFee, student)
    },
  },
}
</script>
